import type { Effect, Reducer } from 'umi'

import { projectTrends } from '../services'

export interface StateType {
  projectTrendData?: any
}

export interface KanbanModelType {
  namespace: string
  state: StateType
  effects: {
    fetchProjectTrends: Effect
  }
  reducers: {
    saveProjectTrends: Reducer<StateType>
  }
}

const KanbanModel: KanbanModelType = {
  namespace: 'kanban',

  state: {
    projectTrendData: []
  },

  effects: {
    *fetchProjectTrends({ payload }, { call, put }) {
      const response = yield call(projectTrends, [])
      yield put({
        type: 'saveProjectTrends',
        payload: response.data
      })
    }
  },

  reducers: {
    saveProjectTrends(state, { payload }) {
      return {
        ...state,
        projectTrendData: payload
      }
    }
  }
}

export default KanbanModel
